import { SET_CUSTOMERS, SET_CUSTOMER_DETAILS } from "@redux/actions/index";

const initialData = { byId: {}, allIds: [] };

const customers = (state = initialData, action) => {
    switch (action.type) {
        case SET_CUSTOMERS:
            return action.payload;
        case SET_CUSTOMER_DETAILS:
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [action.payload.id]: {
                        ...state.byId[action.payload.id],
                        ...action.payload.data,
                    },
                },
            };
        default:
            return state;
    }
};

export default customers;